import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CORE_MESSAGES_SERVICE } from '@shared/core';
import { MessagesService } from './services/messages.service';

@NgModule({
  imports: [CommonModule],
  providers: [MessagesService],
})
export class MessagesModule {
  static forRoot(): ModuleWithProviders<MessagesModule> {
    return {
      ngModule: MessagesModule,
      providers: [{ provide: CORE_MESSAGES_SERVICE, useClass: MessagesService }],
    };
  }
}
